import { Component, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { HubUser } from "@appcore/models/user";
import {
	AuthenticationService,
	AuthorizationService,
	HubConfigsService,
	OrganizationsService,
	StatesService
} from "@appcore/service";
import { Organization, OrgProductLine } from "app/core/data/organization";
import { environment } from "environments/environment";
import { Observable, Subscription } from "rxjs";

@Component({
	selector: "client-org-detail",
	templateUrl: "./organization-detail.component.html",
	providers: [HubConfigsService, OrganizationsService, StatesService]
})
export class ClientOrganizationDetail implements OnInit {
	_orgArray: Organization[];
	_orgProductLinesArray: OrgProductLine[];
	_statesArray = [];
	adminAccess = false;
	checked: boolean;
	cols: any[];
	contentCustomizerAccess = false;
	contentExporterAccess = false;
	currentUser: HubUser;
	currentUserSubscription: Subscription;
	disabled = true;
	exportOrg: string;
	initials = "";
	loading: boolean;
	organization: Organization[];
	organizationName: string;
	orgConfigForm: FormGroup;
	orgID: string;
	plsSupport = environment.plsSupport;
	standardUser = false;
	submitted: boolean;
	userColor = "";
	userName: string;
	userRoles: string;

	courseCustomizer: Observable<boolean>;
	coursesConfiguration: Observable<boolean>;
	productExporter: Observable<boolean>;
	isHostingAccount: Observable<boolean>;
	isHostingOrg = false;

	constructor(
		private authenticationService: AuthenticationService,
		private authorizationService: AuthorizationService,
		private organizationsService: OrganizationsService,
		private statesService: StatesService
	) {}

	ngOnInit(): void {
		this.cols = [
			{ field: "productLineTitle", header: "Title" },
			{ field: "description", header: "Description" },
			{ field: "status", header: "Status" }
		];

		this.authenticationService.getCurrentUserValue().subscribe(currentUser => {
			this.userRoles = currentUser.Groups as string;
			this.initials = currentUser.Initials as string;
			this.userColor = currentUser.ChipColor as string;

			this.courseCustomizer = this.authorizationService.validatePermission(currentUser.ID, "Course Customizer");
			this.coursesConfiguration = this.authorizationService.validatePermission(
				currentUser.ID,
				"Course Configuration"
			);
			this.productExporter = this.authorizationService.validatePermission(currentUser.ID, "Product Exporter");

			// TODO: Convert to Security Permission for logged in user
			this.isHostingAccount = new Observable(subscriber => {
				subscriber.next(true);
				subscriber.complete();
			});

			// User Export Organization not defined, fall back to Default Org
			this.orgID =
				currentUser.ExportOrganization !== "" ? currentUser.ExportOrganization : currentUser.Organization;
			this.organizationName = currentUser.ExportOrgName !== "" ? currentUser.ExportOrgName : currentUser.OrgName;

			if (this.orgID !== undefined || this.orgID !== "") {
				this.loadOrgDataStore();
			}
		});
	}

	loadOrgDataStore(): void {
		this.getStates();
		this.getOrganizationById();
		this.getOrgProductLinesByString();
	}

	getStates(): void {
		this.statesService.getStates().subscribe(statesList => {
			this._statesArray = statesList.map(function (states) {
				return {
					label: states.label,
					value: states.id
				};
			});
		});
	}

	getOrganizationById(): void {
		this.organizationsService.getOrganizationById(this.orgID).subscribe(response => {
			this.organization = <Organization[]>response.payload;
			this.isHostingOrg = this.organization[0].hosting;
		});
	}

	getOrgProductLinesByString(): void {
		this.loading = true;
		this.organizationsService.getOrgProductLinesByString(this.orgID).subscribe(response => {
			this._orgProductLinesArray = <OrgProductLine[]>response.payload;
		});
		this.loading = false;
	}

	refresh(): void {
		this.clearData();
		setTimeout(() => {
			this.loadOrgDataStore();
		}, 500);
	}

	clearData(): void {
		this._orgArray = [];
		this._orgProductLinesArray = [];
		this._statesArray = [];
	}
}
